import React, { useState } from 'react';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.css';
import './DateRangePicker.css'; // Import your custom CSS

const DateRangePicker = ({fromDate, setFromDate, toDate, setToDate}) => {

    const [result, setResult] = useState('');

    const updateDateRange = () => {
        let message = '';
        if (fromDate && toDate) {
            message = `Selected Date Range: ${fromDate.toLocaleDateString()} to ${toDate.toLocaleDateString()}`;
        } else if (fromDate) {
            message = `Start Date: ${fromDate.toLocaleDateString()}`;
        } else if (toDate) {
            message = `End Date: ${toDate.toLocaleDateString()}`;
        }
        setResult(message);
    };

    const handleFromChange = (date) => {
        setFromDate(date[0]);
        updateDateRange();
    };

    const handleToChange = (date) => {
        setToDate(date[0]);
        updateDateRange();
    };

    return (
        <div style={{ fontFamily: 'Arial, sans-serif', margin: '20px 0px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                <div>
                    <label>From:{" "}</label>
                    <Flatpickr
                        options={{
                            dateFormat: 'Y-m-d',
                        }}
                        value={fromDate}
                        onChange={handleFromChange}
                        placeholder="Select start date"
                        style={{ padding: '4px 0px 4px 2px', width: '50%'}}
                    />
                </div>

                <div>
                    <label>To:{" "}</label>
                    <Flatpickr
                        options={{
                            dateFormat: 'Y-m-d',
                            minDate: fromDate, // Prevent selecting an end date before the start date
                        }}
                        value={toDate}
                        onChange={handleToChange}
                        placeholder="Select end date"
                        style={{ padding: '4px 0px 4px 2px', width: '50%'}}
                    />
                </div>
            </div>

            {/* {result && <div style={{ marginTop: '20px' }}>{result}</div>} */}
        </div>
    );
};

export default DateRangePicker;